import { useSelector } from 'react-redux';

export default function useIsLoggedInUserAConcessionaire() {
  return useSelector((state) => state.login?.user?.is_concessionaire);
}
